<div class="position-relative">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-title"> {{ tradesEdit ? 'Edit' : tradesView ? 'View' :
        'Add' }} {{isShown === 'tenant' ? ('client' | translate) : 'Global'}} Trade</div>
    <form [formGroup]="tradesForm" (ngSubmit)="onSubmit()" novalidate>
        <div>
            <div class="mt-top-2 field" *ngIf="(!tradesEdit && !tradesView) && (isShown == 'tenant')">
                <!-- <label for="role" class="d-block">Do you want to:</label> -->
                <mat-radio-group class="field">
                    <mat-radio-button value="new" [checked]='true' (change)="onChangeAdd($event)">Add New Trade
                    </mat-radio-button>
                    <mat-radio-button value="existing" (change)="onChangeAdd($event)">Add Existing Trade
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="mt-top-2 field col-6 pl-0" *ngIf="existingClicked">
                <mat-form-field class="field">
                    <mat-select  [disableOptionCentering]="true" placeholder="Select Existing Trade" formControlName="tradeList">
                        <mat-option *ngFor="let trade of trades; let i = index" [value]="trade.tradeName"
                            (onSelectionChange)="getValues($event)">
                            {{trade.tradeName | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <div class="mt-top-2 field">
                    <app-profile-form formControlName="name" [data]="tradesData" [view]="view" [existingData]="existingData" [existingClicked]="existingClicked"
                        [image]="this.imageId"></app-profile-form>
                        <ng-container *ngIf="formSubmitted && tradesForm.get('name')?.errors">
                            <mat-error *ngIf="tradesForm.get('name')?.errors?.['required']">
                                <em class="fas fa-exclamation-circle mr-2"></em>Enter the required fileds
                            </mat-error>
                            <mat-error *ngIf="tradesForm.get('name')?.errors?.['pattern']">
                                <em class="fas fa-exclamation-circle mr-2"></em>
                                Remove white space from start and end
                                </mat-error>
                        </ng-container>
                </div>
                <div class="mt-top-2 field" *ngIf="isShown === 'global'">
                    <mat-form-field class="field">
                        <mat-label>Select Scope</mat-label>
                        <mat-select  [disableOptionCentering]="true" formControlName="type">
                            <mat-option *ngFor="let item of type; let i = index" [value]="item.name" selected>
                                {{item.name | titlecase}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
                    class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
        </div>
        <div class="btn-basket">
            <button mat-raised-button color="primary" data-dismiss="modal" type="button"
                (click)="closeModal()">Close</button>
            <button *ngIf="!tradesView" mat-raised-button color="primary" type="submit">
                {{ tradesEdit ? 'Update' : 'Submit' }}
            </button>
        </div>
    </form>
</div>